import { Platform } from 'react-native';

const isDevelopment = process.env.NODE_ENV === 'development';

export const BASE_URL = Platform.OS === 'web' ? '' : isDevelopment ? 'http://192.168.1.3' : 'https://rahtab.net';
export const SHIPPING_SERVICE_URL = isDevelopment ? 'http://192.168.1.3/shipping' : 'https://api.rahtab.net/shipping';
